"use client"

import { buildReplyPreviewLabel, type ChatReplyPreview, type ReplySenderContext } from "@/lib/chat/reply-preview"
import {
  chatReplyQuoteSenderClass,
  chatReplyQuoteSnippetClass,
  chatReplyQuoteWrapClass,
} from "@/lib/chat/chat-ui-tokens"

export type ChatReplyQuoteProps = {
  replyTo: ChatReplyPreview
  isOwnMessage: boolean
  compact?: boolean
  showSender?: boolean
  fallbackSenderName?: string
  senderContext?: ReplySenderContext
}

export function ChatReplyQuote({
  replyTo,
  isOwnMessage,
  compact = false,
  showSender = true,
  fallbackSenderName = "User",
  senderContext,
}: ChatReplyQuoteProps) {
  const { senderLabel, snippet } = buildReplyPreviewLabel(replyTo, fallbackSenderName, senderContext)
  const embeddedInSurface = compact && !showSender

  return (
    <div className={chatReplyQuoteWrapClass(isOwnMessage, { compact, embedded: embeddedInSurface })}>
      {showSender ? (
        <p className={chatReplyQuoteSenderClass(isOwnMessage)}>{senderLabel}</p>
      ) : null}
      <p className={chatReplyQuoteSnippetClass(isOwnMessage, { embedded: embeddedInSurface, compact })}>
        {snippet}
      </p>
    </div>
  )
}
